import ServiceMember from "./ServiceMember";

export default class ComplaintSuggestionService extends ServiceMember {
    constructor() {
        super();
        this.baseURL = 'security/user/member/complaintSuggestion';
    }



}